// import React, { useContext, useState, useEffect } from 'react';
// import { AuthContext, } from '../context/AuthContext';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import PromoBanner from './PromoBanner';
// import DMNBanner from './DMNBanner';

// // Configure axios defaults for all requests
// axios.defaults.withCredentials = true;  // Add this line at the top level

// function Dashboard() {
//   const { isAuthenticated, user, setIsAuthenticated } = useContext(AuthContext);
//   const [cases, setCases] = useState([]);
//   const navigate = useNavigate();
//   const [error, setError] = useState(null);

//   const handleViewScores = (caseId) => {
//     navigate(`/cases/${caseId}/scores`);
//   };

//   // useEffect(() => {
//   //   if (isAuthenticated) {
//   //     const fetchCases = async () => {
//   //       try {
//   //         const response = await axios.get('/api/cases');
//   //         setCases(response.data);
//   //       } catch (err) {
//   //         if (err.response && err.response.status === 403) {
//   //           setError('Your subscription has expired. Please renew to continue.');
//   //           setTimeout(() => navigate('/continue-payment'), 3000); // Redirect to payment
//   //         }
//   //         console.error('Failed to fetch cases', err);
//   //         navigate('/continue-payment');
//   //       }
//   //     };
//   //     fetchCases();
//   //   }
//   // }, [isAuthenticated, navigate]);

//   useEffect(() => {
//     if (isAuthenticated) {
//       const fetchCases = async () => {
//         try {
//           const response = await axios.get('/cases', {
//             withCredentials: true,
//             headers: {
//               'Content-Type': 'application/json',
//             }
//           });
//           setCases(response.data);
//         } catch (err) {
//           console.error('Failed to fetch cases:', err);
//           if (err.response?.status === 401) {
//             // Session expired or invalid, redirect to login
//             setIsAuthenticated(false);
//             navigate('/login');
//           } else if (err.response?.status === 403) {
//             setError('Your subscription has expired. Please renew to continue.');
//             setTimeout(() => navigate('/continue-payment'), 3000);
//           }
//         }
//       };
//       fetchCases();
//     }
//   }, [isAuthenticated, navigate, setIsAuthenticated]);




//   // Confirmation dialog handler
//   const handleCaseClick = (caseId, caseTitle) => {
//     const userConfirmed = window.confirm(
//       `You are about to start the case: "${caseTitle}".\n\nProceeding will count as one of your attempts. If you're not ready, click "Cancel".`
//     );

//     if (userConfirmed) {
//       navigate(`/cases/${caseId}`); // Navigate to the case
//     }
//   };

//   return (
//     // <div className="min-h-screen p-8 bg-gray-50">
//     //   <h1 className="text-3xl font-semibold text-gray-900 mb-6 text-center">Welcome to Critical Cases</h1>
//     //   <p className="text-center mb-6">
//     //     {isAuthenticated 
//     //       ? `Go save some virtual lives - you've got this!` 
//     //       : 'Please log in to access more features.'}
//     //   </p>
//   <div className="min-h-screen bg-gray-50">
//     {isAuthenticated && <PromoBanner user={user} />}
//     {isAuthenticated && <DMNBanner user={user} />}
//     <div className="p-8">
//       <h1 className="text-3xl font-semibold text-gray-900 mb-6 text-center">Welcome to Critical Cases</h1>
//       <p className="text-center mb-6">
//         {isAuthenticated 
//           ? `Go save some virtual lives - you've got this!` 
//           : 'Please log in to access more features.'}
//       </p>
//       {isAuthenticated ? (
//         <div>
//           <h2 className="text-2xl font-bold mb-6 text-gray-900">Available Cases</h2>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {cases.map((c) => (
//               <div
//                 key={c._id}
//                 className={`p-4 border border-gray-200 rounded-lg shadow transition ${
//                   c.remainingAttempts === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-white hover:shadow-lg'
//                 }`}
//               >
//                 {c.remainingAttempts > 0 ? (
//                   <Link  className="no-underline" to={`/cases/${c._id}`}>
//                     <h2 className="text-xl font-bold mb-2 text-[#5f56f7] no-underline">{c.title}</h2>
//                   </Link>
//                 ) : (
//                   <h2 className="text-xl font-bold mb-2 text-gray-500">{c.title}</h2>
//                 )}
//                 <p className="text-gray-600">{c.description}</p>
//                 <p className={`text-gray-500 font-semibold mt-2 ${c.remainingAttempts === 0 ? 'text-gray-500' : ''}`}>
//                   Remaining Attempts: {c.remainingAttempts}
//                 </p>
//                 {c.attemptsMade > 0 && (
//                   <button 
//                     onClick={() => handleViewScores(c._id)} 
//                     className="mt-2 text-blue-600 hover:underline"
//                   >
//                     View Scores
//                   </button>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       ) : (
//         <div className="flex justify-center space-x-4 mt-6">
//           <Link to="/login" className="text-blue-600 hover:underline">Login</Link>
//           <Link to="/register" className="text-blue-600 hover:underline">Register</Link>
//         </div>
//       )}
//     </div>
//   </div>
//   );

// }

// export default Dashboard;


// src/components/Dashboard.js
import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import PromoBanner from './PromoBanner';
import DMNBanner from './DMNBanner';

axios.defaults.withCredentials = true;

function Dashboard() {

    // Define your tabs (you can swap these for whatever categories you need)
  const tabs = ['Procedures', 'Ultrasound', 'Difficult Conversations', 'Managing Conflict', 'Patient Centered Communication', 'Reassessment & Troubleshooting', 'Clinical Decision-Making'];


  const { isAuthenticated, user, setIsAuthenticated } = useContext(AuthContext);
  const [cases, setCases] = useState([]);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

    // This runs once, right after Dashboard mounts:
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);  // empty deps → run only on mount


  // Fetch cases when authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    const fetchCases = async () => {
      try {
        const response = await axios.get('/cases', {
          headers: { 'Content-Type': 'application/json' },
        });
        setCases(response.data);
      } catch (err) {
        console.error('Failed to fetch cases:', err);
        if (err.response?.status === 401) {
          setIsAuthenticated(false);
          navigate('/login');
        } else if (err.response?.status === 403) {
          setError('Your subscription has expired. Please renew to continue.');
          setTimeout(() => navigate('/continue-payment'), 3000);
        }
      }
    };

    fetchCases();
  }, [isAuthenticated, navigate, setIsAuthenticated]);

  // Confirmation before starting a case
  const handleCaseClick = (caseId, caseTitle) => {
    const userConfirmed = window.confirm(
      `You are about to start the case: "${caseTitle}".\n\nProceeding will count as one of your attempts. If you're not ready, click "Cancel".`
    );
    if (userConfirmed) {
      navigate(`/cases/${caseId}`);
    }
  };


  // Apply filtering logic based on activeTab
  const filteredCases = cases.filter((c) => {
    if (activeTab === 'Clinical Decision-Making') return c.caseNumber > 0 && c.caseNumber < 1000;
    if (activeTab === 'Difficult Conversations') return c.caseNumber > 999 && c.caseNumber < 2000;
    if (activeTab === 'Managing Conflict') return c.caseNumber > 1999 && c.caseNumber < 3000;
    if (activeTab === 'Patient Centered Communication') return c.caseNumber > 2999 && c.caseNumber < 4000;
    if (activeTab === 'Procedures') return c.caseNumber > 3999 && c.caseNumber < 5000;
    if (activeTab === 'Reassessment & Troubleshooting') return c.caseNumber > 4999 && c.caseNumber < 6000;
    if (activeTab === 'Ultrasound') return c.caseNumber > 5999 && c.caseNumber < 7000;
    // e.g. if you later use c.category:
    // return c.category === activeTab;
  });

  // const tabStyles = {
  //   'Clinical Decision-Making': {
  //     active:   'border-blue-500 text-blue-600 bg-blue-100',
  //     inactive: 'border-transparent text-gray-500 hover:border-blue-500 hover:bg-blue-50',
  //   },
  //   'Difficult Conversations': {
  //     active:   'border-green-500 text-green-600 bg-green-100',
  //     inactive: 'border-transparent text-gray-500 hover:border-green-500 hover:bg-green-50',
  //   },
  //   'Managing Conflict': {
  //     active:   'border-purple-500 text-purple-600 bg-purple-100',
  //     inactive: 'border-transparent text-gray-500 hover:border-purple-500 hover:bg-purple-50',
  //   },
  //   'Patient Centered Communication': {
  //     active:   'border-yellow-500 text-yellow-600 bg-yellow-100',
  //     inactive: 'border-transparent text-gray-500 hover:border-yellow-500 hover:bg-yellow-50',
  //   },
  //   'Procedures': {
  //     active:   'border-red-500 text-red-600 bg-red-100',
  //     inactive: 'border-transparent text-gray-500 hover:border-red-500 hover:bg-red-50',
  //   },
  //   'Reassessment & Troubleshooting': {
  //     active:   'border-teal-500 text-teal-600 bg-teal-100',
  //     inactive: 'border-transparent text-gray-500 hover:border-teal-500 hover:bg-teal-50',
  //   },
  //   'Ultrasound': {
  //     active:   'border-orange-500 text-orange-600 bg-orange-100',
  //     inactive: 'border-transparent text-gray-500 hover:border-orange-500 hover:bg-orange-50',
  //   },
  // };

const tabStyles = {
  'Clinical Decision-Making': {
    icon: '🏥',
    active: 'bg-blue-600 text-white border-blue-700 shadow-md',
    inactive: 'bg-white text-blue-600 border-blue-200 hover:border-blue-400 hover:bg-blue-50',
  },
  'Difficult Conversations': {
    icon: '💬',
    active: 'bg-green-600 text-white border-green-700 shadow-md',
    inactive: 'bg-white text-green-600 border-green-200 hover:border-green-400 hover:bg-green-50',
  },
  'Managing Conflict': {
    icon: '🤝',
    active: 'bg-purple-600 text-white border-purple-700 shadow-md',
    inactive: 'bg-white text-purple-600 border-purple-200 hover:border-purple-400 hover:bg-purple-50',
  },
  'Patient Centered Communication': {
    icon: '👤',
    active: 'bg-yellow-500 text-white border-yellow-600 shadow-md',
    inactive: 'bg-white text-yellow-700 border-yellow-200 hover:border-yellow-400 hover:bg-yellow-50',
  },
  'Procedures': {
    icon: '💉',
    active: 'bg-red-600 text-white border-red-700 shadow-md',
    inactive: 'bg-white text-red-600 border-red-200 hover:border-red-400 hover:bg-red-50',
  },
  'Reassessment & Troubleshooting': {
    icon: '🔍',
    active: 'bg-teal-600 text-white border-teal-700 shadow-md',
    inactive: 'bg-white text-teal-600 border-teal-200 hover:border-teal-400 hover:bg-teal-50',
  },
  'Ultrasound': {
    icon: '📟',
    active: 'bg-orange-500 text-white border-orange-600 shadow-md',
    inactive: 'bg-white text-orange-600 border-orange-200 hover:border-orange-400 hover:bg-orange-50',
  },
};


  return (
    <div className="min-h-screen bg-gray-50">
      {isAuthenticated && <PromoBanner user={user} />}
      {isAuthenticated && <DMNBanner user={user} />}
      {/* Optional: Add a welcome message or banner */}
      <div className="p-2 pb-2">
        <p className="text-xs text-gray-500 mb-1 text-center">
          <strong className="font-bold">Note: The 2026 Certifying Exam has different case types. Please select a tab at the top to filter by case type and get started.</strong> 
        </p>
        <h3 className="text-lg font-bold text-gray-900 text-center mb-0.5">
          Select a Category:
        </h3>
      </div>
      <div className="p-8 pt-2">
        {/* Tab Bar */}
        {/* <div className="flex border-b mb-6">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={
                `py-2 px-4 -mb-px border-b-2 font-medium ` +
                (activeTab === tab
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700')
              }
            >
              {tab}
            </button>
          ))}
        </div> */}
        {/* <div className="flex border-b mb-6">
          {tabs.map(tab => {
            const isActive = activeTab === tab;
            const { active, inactive } = tabStyles[tab] || {};
            return (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`
                  py-2 px-4 -mb-px border-b-2 font-medium transition 
                  ${isActive ? active : inactive}
                `}
              >
                {tab}
              </button>
            );
          })}
        </div> */}

{/*        <div className="flex flex-wrap border-b mb-6">
          {tabs.map((tab) => {
            const isActive = activeTab === tab;
            const { active, inactive } = tabStyles[tab] || {};
            return (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`
                  w-1/2 sm:w-auto text-center py-2 px-2 sm:px-4 text-sm sm:text-base 
                  -mb-px border-b-2 font-medium transition
                  ${isActive ? active : inactive}
                `}
              >
                {tab}
              </button>
            );
          })}
        </div> */}

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-8">
  {tabs.map((tab) => {
    const isActive = activeTab === tab;
    const { active, inactive, icon } = tabStyles[tab] || {};

    return (
      <button
        key={tab}
        onClick={() => setActiveTab(tab)}
        className={`
          /* Layout: Grid makes them uniform length, Flex aligns items inline */
          flex items-center justify-start gap-3 px-4 py-2 rounded-xl border-2 
          font-bold text-sm sm:text-base transition-all duration-200 w-full
          
          /* Clickability Cues */
          cursor-pointer select-none shadow-sm
          active:scale-[0.98] active:translate-y-0.5
          
          /* State Styles */
          ${isActive 
            ? `${active} ring-2 ring-offset-1 ring-blue-100` 
            : `${inactive} hover:-translate-y-0.5 hover:shadow-md`
          }
        `}
      >
        <span className="text-xl shrink-0">{icon}</span>
        <span className="truncate">{tab}</span>
      </button>
    );
  })}
</div>

        {/* Optional error message */}
        {error && (
          <p className="text-red-500 text-center mb-4">
            {error}
          </p>
        )}

        {/* Heading */}
        <h1 className="text-3xl font-semibold text-gray-900 mb-4 text-center">
          {activeTab}
        </h1>

        {/* Cases Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCases.map((c) => (
            <div
              key={c._id}
              className={`p-4 border border-gray-200 rounded-lg shadow transition
                ${c.remainingAttempts === 0
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-white hover:shadow-lg'}`}
            >
              {c.remainingAttempts > 0 ? (
                <h2
                  onClick={() => handleCaseClick(c._id, c.title)}
                  className="text-xl font-bold mb-2 text-blue-600 cursor-pointer"
                >
                  {c.title}
                </h2>
              ) : (
                <h2 className="text-xl font-bold mb-2 text-gray-500">
                  {c.title}
                </h2>
              )}

              <p className="text-gray-600">{c.description}</p>

              <p
                className={`mt-2 font-semibold ${
                  c.remainingAttempts === 0 ? 'text-gray-500' : 'text-gray-700'
                }`}
              >
                Remaining Attempts: {c.remainingAttempts}
              </p>

              {c.attemptsMade > 0 && (
                <button
                  onClick={() => navigate(`/cases/${c._id}/scores`)}
                  className="mt-2 text-blue-600 hover:underline"
                >
                  View Scores
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Fallback when no cases match */}
        {filteredCases.length === 0 && (
          <p className="text-center text-gray-500 mt-8">
            No cases found under "{activeTab}".
          </p>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
